module.exports = __webpack_public_path__ + "img/system.1a85a267.png";